import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://velmonte.es";

export const Seo = ({ title, description, path, lang = "en", altPath, image, jsonLd = [], langAlternates }) => {
  React.useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const alternates = langAlternates || [
    [lang, `${SITE}${path}`],
    ...(altPath ? [[lang === "es" ? "en" : "es", `${SITE}${altPath}`]] : []),
    ["x-default", `${SITE}${lang === "es" ? altPath || path : path}`],
  ];

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE}${path}`} />
      {alternates.map(([hl, href]) => (
        <link key={hl} rel="alternate" hrefLang={hl} href={href} />
      ))}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${SITE}${path}`} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
};
